import { Button } from "@/atoms-react/button/Button.react.tsx";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react.tsx";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react.tsx";
import Loader from "@/atoms-react/loader/Loader.react.tsx";
import { Base, SectionTitleSmall } from "@/atoms-react/text/Text.react.tsx";
import { useQuiz } from "@/features/user/quiz/hooks/use-quiz.ts";
import type { ModalIbanAccountStep, QuizStepProps } from "@/features/user/quiz/types.ts";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { Themes } from "@/types/theme.ts";
import { useTranslation } from "react-i18next";
export const SourceIncomeStep = ({
  setStep,
  quizResponses,
  setQuizResponses,
  stepSettings,
  setPrevStep,
  totalSteps = 8
}: QuizStepProps) => {
  const { t } = useTranslation(["pass"]);
  const { getLanguage } = usei18n();

  const { SourcesIncomeQuery } = useQuiz();
  const { data: response, isLoading: isLoadingSourcesIncome } = SourcesIncomeQuery(getLanguage());
  const sources_income = response?.sourceIncomeCodes;
  const codeOfOtherIncome = sources_income?.find((item) => item.Nom === "Autres revenus")?.id;

  const handleCheckboxChange = (id: string, isChecked: boolean) =>
    setQuizResponses?.((prev) => {
      const newSourcesIncome = isChecked
        ? [...prev.sources_income, { source_income_id: id, comment: "" }]
        : prev.sources_income.filter((income) => Number(income.source_income_id) !== Number(id));

      return {
        ...prev,
        sources_income: newSourcesIncome
      };
    });

  const handleCommentChange = (id: string, otherInputIncomes: string) =>
    setQuizResponses?.((prev) => {
      const updatedSourcesIncome = prev.sources_income.map((income) =>
        income.source_income_id === id ? { ...income, comment: otherInputIncomes } : income
      );
      return {
        ...prev,
        sources_income: updatedSourcesIncome
      };
    });

  const isQuizAnswered = () => {
    if (!quizResponses?.sources_income?.length) return false;
    const otherIncomes = quizResponses?.sources_income?.find(
      (income) => Number(income.source_income_id) === codeOfOtherIncome
    );
    if (otherIncomes && otherIncomes?.comment?.trim() === "") return false;

    return true;
  };

  return (
    <>
      <SectionTitleSmall>
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.incomes.question")}
      </SectionTitleSmall>

      {isLoadingSourcesIncome && (
        <div className="mt-4 mb-4 flex flex-1 items-center justify-center">
          <Loader className="text-gray-500" />
        </div>
      )}
      {!isLoadingSourcesIncome && (
        <>
          <div className="my-4 mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
            {sources_income &&
              sources_income.map((c) => (
                <Checkbox
                  key={c.id}
                  value={
                    quizResponses?.sources_income &&
                    quizResponses.sources_income.some(
                      (income) => Number(income.source_income_id) === Number(c.id)
                    )
                  }
                  onChange={(value) => handleCheckboxChange(c.id.toString(), value)}
                >
                  <Base className="mb-1 cursor-pointer">
                    {getLanguage() === "fr" ? c.Nom : c.NomEn}
                  </Base>
                </Checkbox>
              ))}
          </div>
          {quizResponses?.sources_income &&
            quizResponses.sources_income.some(
              (income) => Number(income.source_income_id) === codeOfOtherIncome
            ) && (
              <div className={"mb-8"}>
                <InputLabel
                  label={t(
                    "olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.incomes.responses.others_comment"
                  )}
                  value={
                    quizResponses.sources_income.find(
                      (income) => Number(income.source_income_id) === codeOfOtherIncome
                    )?.comment as string
                  }
                  onChange={(value: string) =>
                    handleCommentChange(codeOfOtherIncome?.toString() as string, value)
                  }
                  className="mb-1 flex-1 md:mb-0"
                />
              </div>
            )}
          <div className="mt-auto mb-4 flex flex-col items-center">
            <DotsNavigation total={totalSteps} current={stepSettings.current} className="mb-4" />
            <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
              <Button
                theme={Themes.white}
                onClick={() => setPrevStep(stepSettings.previous as ModalIbanAccountStep)}
              >
                {t("olkypass.general.go_back")}
              </Button>

              <Button
                disabled={!isQuizAnswered()}
                onClick={() => setStep(stepSettings.next as ModalIbanAccountStep)}
              >
                {t("olkypass.general.continue")}
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
